import { defineMessages } from 'react-intl';
export default defineMessages({
    alreadyHaveAccount: {
        id: 'auth.alreadyHaveAccount',
        defaultMessage: 'Already have an account?'
    },
    authContainerTagline: {
        id: 'auth.authContainerTagline',
        defaultMessage: 'Your personal weather dashboard. Connect your stations and get real-time data at your fingertips.'
    },
    backToLogin: {
        id: 'auth.backToLogin',
        defaultMessage: 'Back to login'
    },
    checkYourEmail: {
        id: 'auth.checkYourEmail',
        defaultMessage: 'Check your email'
    },
    continueWithApple: {
        id: 'auth.continueWithApple',
        defaultMessage: 'Continue with Apple'
    },
    continueWithFacebook: {
        id: 'auth.continueWithFacebook',
        defaultMessage: 'Continue with Facebook'
    },
    continueWithGoogle: {
        id: 'auth.continueWithGoogle',
        defaultMessage: 'Continue with Google'
    },
    email: {
        id: 'auth.email',
        defaultMessage: 'Email address'
    },
    emailRequiredLoginFacebook: {
        id: 'auth.emailRequiredLoginFacebook',
        defaultMessage: 'Email permission is required.'
    },
    emailVerification: {
        id: 'auth.emailVerification',
        defaultMessage: 'Email verification'
    },
    emailVerificationFailure: {
        id: 'auth.emailVerificationFailure',
        defaultMessage: 'A problem occurred with your email verification.'
    },
    emailVerificationSuccess: {
        id: 'auth.emailVerificationSuccess',
        defaultMessage: 'Your email has been successfully verified.'
    },
    firstName: {
        id: 'auth.firstName',
        defaultMessage: 'First name'
    },
    forgotPassword: {
        id: 'auth.forgotPassword',
        defaultMessage: 'Forgot your password?'
    },
    forgotPasswordSubtitle: {
        id: 'auth.forgotPasswordSubtitle',
        defaultMessage: "Enter your email and we'll send you a link to reset your password."
    },
    lastName: {
        id: 'auth.lastName',
        defaultMessage: 'Last name'
    },
    login: {
        id: 'auth.login',
        defaultMessage: 'Log in'
    },
    loginSubtitle: {
        id: 'auth.loginSubtitle',
        defaultMessage: 'Welcome back! Please enter your details.'
    },
    loginToSmartMixinDescription: {
        id: 'auth.loginToSmartMixinDescription',
        defaultMessage: 'Sign in to SmartMixin to access your weather stations, view analytics, and manage your personal weather dashboard.'
    },
    logout: {
        id: 'auth.logout',
        defaultMessage: 'Log out'
    },
    logoutConfirmation: {
        id: 'auth.logoutConfirmation',
        defaultMessage: 'Do you want to log out?'
    },
    noAccountYet: {
        id: 'auth.noAccountYet',
        defaultMessage: "Don't have an account?"
    },
    or: {
        id: 'auth.or',
        defaultMessage: 'or'
    },
    password: {
        id: 'auth.password',
        defaultMessage: 'Password'
    },
    passwordReset: {
        id: 'auth.passwordReset',
        defaultMessage: 'Password reset'
    },
    passwordResetSuccess: {
        id: 'auth.passwordResetSuccess',
        defaultMessage: 'Your password has been successfully updated.'
    },
    register: {
        id: 'auth.register',
        defaultMessage: 'Create account'
    },
    registerDescription: {
        id: 'auth.registerDescription',
        defaultMessage: 'Create a free SmartMixin account to connect your weather stations, track weather data, and access powerful analytics tools.'
    },
    registerSubtitle: {
        id: 'auth.registerSubtitle',
        defaultMessage: 'Create your account to get started.'
    },
    restorePassword: {
        id: 'auth.restorePassword',
        defaultMessage: 'Restore Password'
    },
    restorePasswordSuccess: {
        id: 'auth.restorePasswordSuccess',
        defaultMessage: "We've just sent you a password reset link at {emailAddress} with further instructions."
    },
    sendReset: {
        id: 'auth.sendReset',
        defaultMessage: 'Send reset instructions'
    },
    signInWithApple: {
        id: 'auth.signInWithApple',
        defaultMessage: 'Sign in with Apple'
    },
    socialAccount: {
        id: 'auth.socialAccount',
        defaultMessage: 'or use your account'
    },
    // Staff second factor on the (superuser-only) Debug screens.
    staffVerificationCode: {
        id: 'auth.staffVerificationCode',
        defaultMessage: 'Verification code'
    },
    staffVerificationExpiresIn: {
        id: 'auth.staffVerificationExpiresIn',
        defaultMessage: 'Verified. Expires in {duration}.'
    },
    staffVerificationInvalidCode: {
        id: 'auth.staffVerificationInvalidCode',
        defaultMessage: 'Incorrect code. Try again.'
    },
    staffVerificationLoginAsStopped: {
        id: 'auth.staffVerificationLoginAsStopped',
        defaultMessage: 'Login As was stopped: enter a verification code on the Debug screen to continue.'
    },
    staffVerificationNotEnrolled: {
        id: 'auth.staffVerificationNotEnrolled',
        defaultMessage: 'No authenticator app is set up for your account. Add one in the back office security settings.'
    },
    staffVerificationPrompt: {
        id: 'auth.staffVerificationPrompt',
        defaultMessage: 'Enter the 6-digit code from your authenticator app, or a recovery code, to use Login As and user search.'
    },
    staffVerificationSetupLink: {
        id: 'auth.staffVerificationSetupLink',
        defaultMessage: 'Add an authenticator app'
    },
    staffVerificationSubmit: {
        id: 'auth.staffVerificationSubmit',
        defaultMessage: 'Verify'
    },
    staffVerificationTitle: {
        id: 'auth.staffVerificationTitle',
        defaultMessage: 'Staff verification'
    }
});
